import Creator from './Creator'
import _utils from './_utils'

export const downloadCSV = _utils.downloadCSV

export default Creator;